// Textos personalizados desde el admin (Admin → Textos). Se aplican sobre las
// traducciones por defecto en TODO el sitio: claves de los JSON y de empresasTxt.
import i18n from './i18n';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3002';
const LANGS = ['es', 'en', 'ru', 'fr'];

export function aplicarTextos(porIdioma, { refrescar = true } = {}) {
  let n = 0;
  for (const l of LANGS) {
    for (const [clave, valor] of Object.entries((porIdioma && porIdioma[l]) || {})) {
      if (typeof valor === 'string' && valor.trim()) { i18n.addResource(l, 'translation', clave, valor); n++; }
    }
  }
  if (n && refrescar) i18n.changeLanguage(i18n.resolvedLanguage || i18n.language);
  return n;
}

export async function cargarTextos() {
  try {
    const r = await fetch(`${BASE}/api/textos`);
    if (!r.ok) return;
    aplicarTextos(await r.json());
  } catch { /* sin conexión: se usan los textos por defecto */ }
}
